import { withAuthHeaders } from "../api/auth";
import { patientActions } from "./patients-slice";


export const fetchPatientsDetails = (clinicName) => {
    return async (dispatch) => {
        try {
            const trimmedClinic = clinicName ? clinicName.replace(/\s+/g, " ").trim() : "";
            let url = `${process.env.REACT_APP_BACKEND_URL}/api/patients`;
            if (trimmedClinic) {
                url += `?clinicName=${encodeURIComponent(trimmedClinic)}`;
            }
            const response = await fetch(url, {
                headers: withAuthHeaders(),
            });

            if (!response.ok) {
                throw new Error('Could not fetch appointment data!');
            }

            const responseData = await response.json();
            const data = responseData?.data || responseData;

            // Strict Isolation for Legacy Users (No clinicName)
            if (!trimmedClinic) {
                const filteredData = data.filter(
                    p => !p.clinicName || p.clinicName.trim() === ""
                );
                dispatch(patientActions.setPatients(filteredData));
                return filteredData;
            }

            dispatch(patientActions.setPatients(data));
            return data;
        }

        catch (error) {
            console.error("Error fetching patients:", error);
            throw error;
        }


    }
}
